module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAYAAAAGuM1UAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAo0lEQVQYlY3RUU3EYBAE4O/qoBYOCUVCSdbAWcBCK6GVABIOA5Og4SSAhbPAy0/yE0rCvGyymZmdzJ6qasaMW5I3B6iqBSP2ATc8Y6uq8YA8YcOU5D4kuWPHGcvBga3NFU6d0zsmPDQTVXXBFXuSFYbO6bXlfOl2C74T+HGhOV5xwWMrYsOa5E/BiI9WxBmfSZ56Th9JV8DcBLv/oKou7T+/8AUx5zO78ozuMwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yxsc/10.png
// module id = 7zFJ
// module chunks = 1